<script setup lang="ts">
import { reactive, onMounted } from 'vue'

import { useNotifyStore } from '../../stores/notify'

import type { NotificationType } from '../../stores/notify'

const props = withDefaults(defineProps<{
  id: number,
  type?: NotificationType,
  delay?: number,
  title: string,
  message?: string | null
}>(), {
  type: 'success',
  delay: 10000,
  message: null
})

const { deleteNotification } = useNotifyStore()

const timer = reactive<{ id: ReturnType<typeof setTimeout> | null, start: number | null, delay: number }>({
  id: null,
  start: null,
  delay: props.delay
})

const stopTimer = () => {
  if (timer.id) {
    clearTimeout(timer.id)
    timer.id = null
  }
}

const startTimer = () => {
  timer.start = Date.now()
  timer.id = setTimeout(() => deleteNotification(props.id), timer.delay)
}

const pauseTimer = () => {
  stopTimer()
  timer.delay -= Date.now() - (timer.start ?? Date.now())
}

const resumeTimer = () => {
  stopTimer()
  startTimer()
}

onMounted(() => {
  startTimer()
})
</script>

<template>
  <div class="bx-notify__item-wrapper">
    <div :class="['bx-notify__item', `bx-notify__item--${type}`]"
         @mouseleave="resumeTimer()"
         @mouseenter="pauseTimer()">
      <button type="button"
              aria-label="Close"
              class="bx-notify__close"
              @click="deleteNotification(id)">
        <svg class="icon icon-close">
          <use href="#close" />
        </svg>
      </button>
      <span class="bx-notify__icon">
        <svg v-if="type==='success'"
             class="icon icon-check">
          <use href="#check" />
        </svg>
        <svg v-if="type==='error'"
             class="icon icon-close">
          <use href="#close" />
        </svg>
        <span v-if="type==='warning'">!</span>
        <span v-if="type==='info'">i</span>
      </span>
      <div>
        <h3>{{ title }}</h3>
        {{ message }}
      </div>
    </div>
  </div>
</template>
